/**
 * Colores de identificación de cilindros de gas grado médico.
 *
 * El catálogo de tanques de gas (medicalGasTanks) guarda el HEX del color.
 * Aquí centralizamos la lista fija (nombre + hex) y los helpers para
 * pintar el cuadrito y resolver el nombre legible, de forma que tanto el
 * catálogo como el inventario usen exactamente la misma paleta.
 *
 * OJO: esta lista NO sigue la paleta de marca y no debe seguirla. Son los
 * colores físicos de identificación del cilindro (norma de gases medicinales):
 * el azul tiene que verse azul aunque el azul no exista en la paleta de Epione.
 */
export interface GasColor {
  name: string;
  hex:  string;
}

export const GAS_CYLINDER_COLORS: GasColor[] = [
  { name: 'Verde',    hex: '#14853d' },
  { name: 'Blanco',   hex: '#FFFFFF' },
  { name: 'Azul',     hex: '#1010eb' },
  { name: 'Gris',     hex: '#9E9E9E' },
  { name: 'Amarillo', hex: '#fb7506' },
  { name: 'Negro',    hex: '#212121' },
  { name: 'Café',     hex: '#6D4C41' },
  { name: 'Naranja',  hex: '#cf5009' },
  { name: 'Rojo',     hex: '#cc0025' },
  { name: 'Morado',   hex: '#6A1B9A' },
];

/**
 * Hex a pintar para un valor de color guardado. El valor normalmente ya
 * es un hex (lo guarda el select), pero si viniera un nombre (datos viejos
 * o carga por Excel) lo resolvemos contra la lista fija. Devuelve '' cuando
 * no hay color, para que el template pinte transparente.
 */
export function gasColorHex(value: any): string {
  if (!value) return '';
  const v = String(value).trim();
  if (v.startsWith('#')) return v;
  const byName = GAS_CYLINDER_COLORS.find(c => c.name.toLowerCase() === v.toLowerCase());
  return byName ? byName.hex : v;
}

/** Nombre legible de un color guardado (hex → nombre; fallback al valor). */
export function gasColorLabel(value: any): string {
  if (!value) return '';
  const v = String(value).trim();
  const byHex = GAS_CYLINDER_COLORS.find(c => c.hex.toLowerCase() === v.toLowerCase());
  if (byHex) return byHex.name;
  const byName = GAS_CYLINDER_COLORS.find(c => c.name.toLowerCase() === v.toLowerCase());
  return byName ? byName.name : v;
}
